import React from "react";
import axios from 'axios';
import { store } from "../../redux/store";
import { connect } from "react-redux";
import history from "../../auth/history";
import $ from "jquery";
import UserJpg from "../../../src/assests/images/user.jpg";
import './dashboardHeader.css';
import moment from "moment";
import { resetMiscData } from './../../redux/misc-data/misc-data.action';
import FinxPayLogo from "../../assests/images/finxpay.png";
import FinxPayIcon from "../../assests/images/logo.png";
import authReducer from './../../redux/auth/auth.reducer';
import { Link } from "react-router-dom";
import tokenErrorHandler from "../tokenErrorHandler";
const httpClient = axios.create();
class RegisterRetailerHeader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            password: '',
            otpRef: '',
            message: '',
            retailerBalanceVal: 0
        }
    }



    componentDidMount() {
    }
    componentWillUnmount() {
    }

    goBackUrl = () => {
        window.location.href = this.props.callBackUrl;
    }


    render() {

        return (
            <div class="header">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-2 col-md-5 col-lg-6 col-xl-5">
                            <div class="logo">
                                <Link to="/finxpy-login">
                                    <img src={'/images/' + 'finxpay.png'} alt="FinXpay" class="d-none d-sm-block" />

                                </Link>

                            </div>
                        </div>

                        <div class="col-10 col-md-7 col-lg-6 col-xl-7">
                            <div class="profile-box">
                                <Link to='/finxpay-login'>
                                    <button type="button" class="goback"
                                    >Back to Login</button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = ({ errorMessageReduce: { errorMessage, loginErrorMessage },
    miscReduce: { phone, agentInfo, token, loginTime, partner, logoName, claimLoadShow }
    , authReduce: { callBackUrl } }
) => ({
    errorMessage, loginErrorMessage, phone, agentInfo, token, loginTime, partner, logoName, claimLoadShow,
    callBackUrl
});




export default connect(mapStateToProps, null)(RegisterRetailerHeader);
